import CityPageTemplate from "../city-template/CityPageTemplate";
import { falmouthConfig } from "./data";

export default function FalmouthPage() {
  return <CityPageTemplate config={falmouthConfig} />;
}